/**
 * Shared demo credentials for cloud AI agents on demo.qawaem.live.
 * Must match apps/web-apps/Console/worker/lib/demo-agent-license.ts
 */

export const DEMO_AGENT_COMPANY_ID = 'QAWAEM_DEMO';
export const DEMO_AGENT_LICENSE_KEY = 'Qawaem-DEMO-AGENT-ONLINE';

export function getDemoAgentLicense() {
  return {
    companyId: DEMO_AGENT_COMPANY_ID,
    licenseKey: DEMO_AGENT_LICENSE_KEY,
    isDemo: true,
  };
}

export function isDemoAgentCredential(licenseKey, companyId) {
  return (
    String(licenseKey || '') === DEMO_AGENT_LICENSE_KEY &&
    String(companyId || '') === DEMO_AGENT_COMPANY_ID
  );
}
